import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {AgencyUser, CreateAgencyUserPasswordRequest} from "../../entities/AgencyUser.ts";

export class LinkAgencyUserPasswordUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, uid: string, data: CreateAgencyUserPasswordRequest): Promise<AgencyUser> {
        return this.agencyRepository.linkAgencyUserPassword(agencyId, uid, data)
    }
}
